import Appsignal from "@appsignal/javascript"
import { plugin } from "@appsignal/plugin-breadcrumbs-network"

export let appsignal: Appsignal

const appsignalKey = import.meta.env.VITE_APPSIGNAL_KEY

if (process.client && appsignalKey && appsignalKey !== "YOUR_APPSIGNAL_KEY") {
  appsignal = new Appsignal({
    key: appsignalKey,
    revision: import.meta.env.VITE_COMMIT_SHA
  })
  appsignal.use(plugin())
}
